<template>
    <b-container>
        <h4 class="mt-4 p-2 text-center text-primary text-uppercase">Limites</h4>
        <b-row class="justify-content-center">
            <b-col cols="12" lg="3" class="mt-4 mb-2 d-none d-lg-block">
                <b-button variant="default" pill block size="sm" title="Agregar" @click="infoData" v-b-modal.data>
                    <i class="material-icons mdi mdi-source-branch-plus"></i>&nbsp;
                    <span>Nuevo Limite</span>
                </b-button>
            </b-col>
            <b-col cols="12" lg="9" class="mt-4 mb-2">
                <b-form-group class="mb-0">
                    <b-input-group size="sm">
                        <b-form-input id="search" v-model="search" type="search" placeholder="Buscar" class="pad-3-15 btlr-30 bblr-30"></b-form-input>

                        <b-input-group-append>
                            <b-button variant="default" :disabled="!search" @click="search = ''" class="m-0 btlr-0 bblr-0">
                                <i class="material-icons mdi mdi-close"></i>
                            </b-button>
                        </b-input-group-append>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="12" class="px-0">
                <b-table
                    :items="items"
                    :fields="fields"
                    responsive="sm"
                    class="my-2 border-bottom"
                    stacked="sm"
                    hover
                    small
                    show-empty
                    no-border-collapse
                    table-variant="light"
                    details-td-class="px-0"
                    empty-filtered-text="No hay limites que coincidan con la búsqueda"
                    empty-text="No hay limites para mostrar"
                    :current-page="currentPage"
                    :per-page="perPage"
                    :filter="search"
                    :busy="isBusy"
                    @filtered="onFiltered">
                    <template #cell(actions)="row">
                        <b-button variant="default" size="sm" title="Editar" @click="infoData(row.item.id)" v-b-modal.data>
                            <i class="material-icons">edit</i>
                        </b-button>
                        <b-button variant="danger" size="sm" title="Eliminar" @click="trash(row.item.id)">
                            <i class="material-icons">delete</i>
                        </b-button>
                    </template>

                    <template #table-busy>
                        <div class="text-center text-danger my-4">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>Actualizando...</strong>
                        </div>
                    </template>
                </b-table>

                <!-- Modal Add/Edit Integration -->
                <b-modal
                    id="data"
                    centered
                    no-fade
                    header-class="text-center"
                    header-bg-variant="primary"
                    header-text-variant="light"
                    header-close-variant="light"
                    footer-class="border-0"
                    hide-footer
                    body-class="text-center px-4 my-4"
                    :title="(form.id ? 'Actualizar' : 'Agregar Nuevo') + ' Limite'"
                    tabindex="-1"
                    role="dialog"
                    size="lg"
                    aria-hidden="true">
                    <b-form id="formData" @submit.stop.prevent="form.id !== 0 ? save(form.id) : save()">
                        <b-row class="justify-content-center">
                            <b-col cols="12" md="5" align-self="start">
                                <b-form-group :label="labels.item+':'">
                                    <b-form-select
                                        name="item"
                                        :options="values"
                                        :value="form.item"
                                        v-model="form.item"
                                        class="form-control text-center"
                                        v-validate="'required:true'"
                                        :state="validateState('item')"
                                        :data-vv-as="(labels.item).toLowerCase()"
                                        :disabled="loading"
                                        aria-describedby="item-live-feedback"
                                        value-field="code"
                                        text-field="name"
                                    ></b-form-select>
                                    <b-form-invalid-feedback id="item-live-feedback">
                                        {{ veeErrors.first('item') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <template v-for="(v, k) in form.values">
                                <b-col cols="12" md="10" align-self="start" v-if="form.values[k].key === 'country'">
                                    <h6 class="pt-2">
                                        <u>Paises</u>
                                    </h6>
                                </b-col>
                                <b-col cols="12" md="5" align-self="start">
                                    <b-form-group :label="labels.values[k].name+':'">
                                        <b-form-input
                                            :name="'value' + k"
                                            v-model="form.values[k].value"
                                            :type="form.values[k].key === 'value' ? 'number': 'text'"
                                            class="text-center"
                                            v-validate="(form.values[k].key === 'payer' || form.values[k].key === 'destiny' ? '' : 'required:true')"
                                            :state="validateState('value' + k)"
                                            :data-vv-as="(labels.values[k].name).toLowerCase()"
                                            :disabled="loading"
                                            :aria-describedby="'value' + k + '-live-feedback'"/>
                                        <b-form-invalid-feedback :id="'value' + k + '-live-feedback'">
                                            {{ veeErrors.first('value' + k) }}
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                </b-col>
                            </template>
                        </b-row>
                        <b-row class="justify-content-center">
                            <b-col cols="12" md="10" align-self="start" class="my-4">
                                <b-button type="submit" variant="default" size="lg" pill class="align-middle px-5"
                                          form="formData" :disabled="loading">
                                    <b-spinner small type="grow" v-if="loading"></b-spinner>
                                    <b-icon icon="upload" aria-hidden="true" class="align-middle" v-else></b-icon>
                                    &nbsp;&nbsp;<span>{{ loading ? (form.id === 0 ? 'Guardando...' : 'Actualizando...') : (form.id === 0 ? 'Guardar' : 'Actualizar' ) }}</span>
                                </b-button>
                            </b-col>
                        </b-row>
                    </b-form>
                </b-modal>
            </b-col>
            <b-col sm="5" md="6">
                <b-form-group
                    label="Mostrar:"
                    label-for="per-page-select"
                    label-cols-sm="4"
                    label-cols-md="6"
                    label-cols-lg="9"
                    label-align-sm="right"
                    label-size="sm"
                    class="mt-2 mb-8">
                    <b-form-select
                        id="per-page-select"
                        v-model="perPage"
                        :options="pageOptions"
                        size="sm"
                    ></b-form-select>
                </b-form-group>
            </b-col>
            <b-col sm="7" md="6">
                <b-pagination
                    v-model="currentPage"
                    :total-rows="totalRows"
                    :per-page="perPage"
                    align="fill"
                    size="sm"
                    class="mt-2 mb-8"
                ></b-pagination>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
import axios from "axios";

export default {
    name: "Limits",
    data: () => ({
        labels: {
            item: 'Categoría',
            data: {
                payer: 'Corresponsal',
                value: 'Valor',
                currency: 'Moneda',
                country: 'Remitente',
                destiny: 'Destinatario',
            },
            values: [
                { name: 'Corresponsal' },
                { name: 'Valor' },
                { name: 'Moneda (ISO 20022)' },
                { name: 'Remitente (ISO 2)' },
                { name: 'Destinatario (ISO 2)' }
            ]
        },
        form: {
            id: 0,
            item: null,
            payer: null,
            type: null,
            value: 0,
            currency: null,
            country: null,
            data: {},
            values: [
                { key: 'payer', value: null },
                { key: 'value', value: null },
                { key: 'currency', value: null },
                { key: 'country', value: null },
                { key: 'destiny', value: null }
            ]
        },
        values: [
            { code: 'min', name: 'Mínimo' },
            { code: 'max', name: 'Máximo' }
        ],
        loading: false,
        isBusy: true,
        search: '',
        fields: [
            { key: 'payer', label: 'Corresponsal', sortable: true },
            { key: 'type', label: 'Categoria', sortable: true },
            { key: 'value', label: 'Valor', sortable: true },
            { key: 'currency', label: 'Moneda', sortable: true },
            { key: 'country', label: 'País', sortable: true },
            { key: 'actions', label: 'Acción', sortable: false }
        ],
        items: [],
        totalRows: 1,
        currentPage: 1,
        perPage: 25,
        pageOptions: [25, 50, 100, { value: -1, text: "Todos" }]
    }),
    mounted() {
        this.$emit('loader');
        this.$emit('section', 'limitspage');
        this.totalRows = this.items.length;
        this.getIni();
    },
    methods: {
        getIni() {
            axios.get('/api/settings/limits').then((res) => {
                if (res.data.status === 'success') {
                    this.items = res.data.items;
                    this.totalRows = this.items.length;
                }
            }).catch(err => {
                this.$root.$bvToast.toast(err.response.data.errors, {
                    title: 'Notificación',
                    headerClass: 'd-none',
                    variant: 'error',
                    toaster: 'b-toaster-top-right',
                    autoHideDelay: 5000,
                    solid: true,
                    appendToast: true
                });
            }).then(() => {
                this.isBusy = false;
            });
            this.timeout = setTimeout(this.getIni, 180000);
        },
        infoData(id) {
            this.form = {
                id: 0,
                item: null,
                payer: null,
                type: null,
                value: 0,
                currency: null,
                country: null,
                data: {},
                values: [
                    { key: 'payer', value: null },
                    { key: 'value', value: null },
                    { key: 'currency', value: null },
                    { key: 'country', value: null },
                    { key: 'destiny', value: null }
                ]
            };
            if (id) {
                const items = this.items;

                for (let i = 0; i < items.length; i++) {
                    if (items[i].id === id) {
                        this.form = items[i];
                    }
                }
            }
        },
        save(id) {
            this.$validator.validateAll().then(result => {
                if (!result) {
                    return;
                }
                this.loading = true;
                let url = 'add';
                if (id) {
                    url = id + '/edit';
                }
                let formData = new FormData();
                formData.append('id', this.form.id);
                formData.append('name', this.form.item);
                formData.append('values', JSON.stringify(this.form.values));
                axios.post('/api/settings/limits/' + url, formData, {
                    headers: {'Content-Type': 'application/x-www-form-urlencoded'}
                }).then((res) => {
                    this.$root.$bvToast.toast(res.data.msg, {
                        title: 'Notificación',
                        headerClass: 'd-none',
                        variant: res.data.status,
                        toaster: 'b-toaster-top-right',
                        autoHideDelay: 5000,
                        solid: true,
                        appendToast: true
                    });
                    if (res.data.status === 'success') {
                        this.getIni();
                        this.$bvModal.hide('data');
                        this.infoData();
                        this.$validator.reset();
                    }
                }).catch(err => {
                    this.$root.$bvToast.toast(err.response.data.errors, {
                        title: 'Notificación',
                        headerClass: 'd-none',
                        variant: 'error',
                        toaster: 'b-toaster-top-right',
                        autoHideDelay: 5000,
                        solid: true,
                        appendToast: true
                    });
                }).then(() => {
                    this.loading = false;
                });
            });
        },
        trash(id) {
            let name = '';
            let currency = '';
            const items = this.items;

            for (let i = 0; i < items.length; i++) {
                if (items[i].id === id) {
                    name = items[i].name;
                    currency = items[i].currency;
                }
            }

            this.$swal({
                title: '¿Estas seguro de eliminar esta configuración de limite?',
                text: 'Limite: ' + name + ' - ' + currency,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Si, eliminar',
                confirmButtonColor: '#28a745',
                cancelButtonText: 'En otro momento',
                cancelButtonColor: '#dc3545',
                allowOutsideClick: false,
                allowEscapeKey: false,
                reverseButtons: true
            }).then((result) => {
                if (result.value) {
                    axios.get('/api/settings/limits/' + id + '/delete').then((res) => {
                        if (res.data.status === 'success') {
                            for (let i = 0; i < items.length; i++) {
                                if (items[i].id === id) {
                                    items.splice( i, 1 );
                                    this.totalRows = this.items.length;
                                }
                            }
                        }
                    }).catch(err => {
                        this.$root.$bvToast.toast(err.response.data.errors, {
                            title: 'Notificación',
                            headerClass: 'd-none',
                            variant: 'error',
                            toaster: 'b-toaster-top-right',
                            autoHideDelay: 5000,
                            solid: true,
                            appendToast: true
                        });
                    });
                }
            });
        },
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
        validateState(ref) {
            if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
                return !this.veeErrors.has(ref);
            }
            return null;
        },
        resetValidationState() {
            this.isValid = undefined
        }
    },
    destroyed() {
        clearTimeout(this.timeout);
    }
}
</script>

<style scoped>

</style>
